import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { IBreadcrumb, Breadcrumb } from '../services/breadcrumb';

@Component({
  selector: 'breadcrumb',
  styleUrls: ['./breadcrumb.component.scss'],
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent {
  public breadcrumb: IBreadcrumb = [];

  constructor(@Inject(Breadcrumb) breadcrumb: Breadcrumb, private changeDetector: ChangeDetectorRef) {
    breadcrumb.registerComponent(this);
  }

  public update(breadcrumb: IBreadcrumb) {
    this.breadcrumb = breadcrumb;
    this.changeDetector.markForCheck();
  }
}
